// src/views/UnauthorizedPage.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useAuth0 } from '@auth0/auth0-react';
import styles from '../styles/UnauthorizedPage.module.css';

// get the public URL path
const heroBg = process.env.PUBLIC_URL + '/landing-bg.png';

export default function UnauthorizedPage() {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ 
      returnTo: window.location.origin,
      post_login_redirection_uri: window.location.origin 
    });
  };

  return (
    <div className={styles.wrapper}>
      <section
        className={styles.hero}
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className={styles.heroInner}>
          <div className={styles.heroContent}>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className={styles.icon}
            />
            <h1 className={styles.title}>Access Denied</h1>
            <p className={styles.subtitle}>
              You don't have permission to view the dashboard.
            </p>
            <p className={styles.subtitle}>
              Please contact a Musuko Media administrator to request access.
            </p>
            <button 
              className={styles.logoutButton}
              onClick={handleLogout}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              Logout
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
